import ListIqamaUpdateList from "./ListIqamaUpdateList";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIqamaData } from "./../../../../../store/Api";
import { setAppError, setBreadCrumb } from "./../../../../../store/userSlice";
import FileUploadElement from "../../../../../ReusableComponents/UploadFile/uplaodFile";

export default function IqamaUpdateList({ setData, setIndex }) {
  const IqamaData = useSelector((state) => state.iqamaData);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  useEffect(() => {
    dispatch(getIqamaData(token));
    setData(IqamaData?.data != null ? IqamaData?.data.length : 0);
  }, []);

  const updateData = () => {
    dispatch(getIqamaData(token));
  };

  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
  });

  return (
    <>
      {showPromptElement.open && (
        <FileUploadElement
          title={"Upload Tamplate with Border Number"}
          subTitle={"Upload templete"}
          showFileUploadElement={showPromptElement}
          setShowFileUploadElement={setShowPromptElement}
          uploadFile={""}
        />
      )}

      <ListIqamaUpdateList
        titles={[
          "S.NO.",
          "EMPLOYEE ID",
          "BORDER NUMBER",
          "PASSPORT NUMBER",
          "VISA PROVIDER",
          "SPONSOR ID",
          "IQAMA NUMBER",
          "IQAMA NUMBER RECEIVED DATE",
          "IQAMA NUMBER ISSUE DATE",
          "IQAMA NUMBER EXPIRY DATE (G)",
          "IQAMA NUMBER EXPIRY DATE (H)",
          "IQAMA AGEING DAYS",
          "IQAMA VALID DAYS",
          "STATUS",
        ]}
        list={IqamaData}
        loading={loading}
        token={token}
        updateData={updateData}
        uploadFile={setShowPromptElement}
        setDataLen={setData}
        setIndex={setIndex}
      />
    </>
  );
}
